import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Header from "./components/Header";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import LogShipment from "./pages/LogShipment";
import StockShipment from "./pages/StockShipment";
import StockedShipments from "./pages/StockedShipments";
import CompletedTasks from "./pages/CompletedTasks";
import MyPendingPickups from "./pages/MyPendingPickups";
import LowInventory from "./pages/LowInventory";
import PreparationQueue from "./pages/PreparationQueue";
import Shipments from "./pages/Shipments";
import ShipmentDetail from "./pages/ShipmentDetail";
import CrewLeaders from "./pages/CrewLeaders";
import RequestForMaterial from "./pages/RequestForMaterial";
import MyRequests from "./pages/MyRequests";
import AdminRoles from "./pages/AdminRoles";
import AdminDeletions from "./pages/AdminDeletions";
import AdminDropdowns from "./pages/AdminDropdowns";
import Reports from "./pages/Reports";
import Equipment from "./pages/Equipment";
import EquipmentForm from "./pages/EquipmentForm";
import EquipmentDetail from "./pages/EquipmentDetail";
import ToolRequest from "./pages/ToolRequest";
import ToolRequestsList from "./pages/ToolRequestsList";
import ToolRequestDetail from "./pages/ToolRequestDetail";
import AdminToolCatalog from "./pages/AdminToolCatalog";
import Help from "./pages/Help";

function AppShell() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          offset="80px"
          toastOptions={{
            style: {
              fontFamily: '"IBM Plex Sans", sans-serif',
              fontWeight: 600,
              borderRadius: "4px",
              border: "2px solid",
              zIndex: 60,
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/shipments" element={<Shipments />} />
            <Route path="/shipments/new" element={<LogShipment />} />
            <Route path="/shipments/receive" element={<LogShipment />} />
            <Route path="/shipments/stocked" element={<StockedShipments />} />
            <Route path="/shipments/:id" element={<ShipmentDetail />} />
            <Route path="/shipments/:id/stock" element={<StockShipment />} />
            <Route path="/preparation-queue" element={<PreparationQueue />} />
            <Route path="/my-pickups" element={<MyPendingPickups />} />
            <Route path="/inventory" element={<LowInventory />} />
            <Route path="/completed-tasks" element={<CompletedTasks />} />
            <Route path="/crew-leaders" element={<CrewLeaders />} />
            <Route path="/requests/new" element={<RequestForMaterial />} />
            <Route path="/my-requests" element={<MyRequests />} />
            <Route path="/admin/roles" element={<AdminRoles />} />
            <Route path="/admin/deletions" element={<AdminDeletions />} />
            <Route path="/admin/dropdowns" element={<AdminDropdowns />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/equipment" element={<Equipment />} />
            <Route path="/equipment/new" element={<EquipmentForm />} />
            <Route path="/equipment/:id" element={<EquipmentDetail />} />
            <Route path="/equipment/:id/edit" element={<EquipmentForm />} />
            <Route path="/tool-requests" element={<ToolRequestsList />} />
            <Route path="/tool-requests/new" element={<ToolRequest />} />
            <Route path="/tool-requests/:id" element={<ToolRequestDetail />} />
            <Route path="/admin/tool-catalog" element={<AdminToolCatalog />} />
            <Route path="/help" element={<Help />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
